import { useLayoutEffect } from 'react';

export default function MultiWindowHost() {
    const opener = window.opener;

    useLayoutEffect(() => {
        window.postMessage({ type: 'ready' }, window.location.origin);
        window.onbeforeunload = () => {
            // This needs to be sent through post message otherwise it's unreliable
            window.postMessage({ type: 'closing' }, window.location.origin);
        };
    }, []);

    if (!opener) {
        return <div className="h-100 d-flex align-items-center justify-content-center">No parent window found.</div>;
    }

    return <div id="window-content" className="w-100 h-100"></div>;
}
